module.exports = __webpack_public_path__ + "static/media/greyTruck.dd1becce.svg";